import React from 'react';

const ResetPass = () => {
    return (
        <div>
            <h2>ResetPass</h2>
        </div>
    );
};

export default ResetPass;